export default __webpack_public_path__ + "static/media/4.4619124e.png";